const getApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return 'https://railways.makemytrip.com/api';
  }

  const { hostname } = window.location;
  if (hostname.includes('makemytrip.com')) {
    return 'https://railways.makemytrip.com/api';
  }

  return '/api';
};

export const SERVER_URL = getApiBaseUrl();
export const MMT_SERVER_URL = 'https://www.makemytrip.com/api';
// export const SERVER_URL = 'http://localhost:3001/api';
